import React from "react";
import reactDom from "react-dom";
import { BsyUtils } from "../../utils/Utils";

import BsyFormWidgetManager from "./BsyFormWidgetManager";
import BsySLoading from "../BsySLoading";
//管理整个表所有的数据
export default class BsyFormDataManager {
  constructor(props) {
    this.element = props.element;
    this.dataTable = props.dataTable;
    this.appId = props.appId;
    this.formId = props.formId;
    this.entryId = props.entryId;
    this.authGroupId = props.authGroupId;
    this.ignoreAuth = props.ignoreAuth;
    this.noRely = props.noRely;
    this.items = [...props.items];
    this.formMap = {};
    this.popupFormPath = [...props.popupFormPath];
    this.type = props.type;
    this.optAuth = props.optAuth;

    this.dataUrl = "/data/read";
    this.extDashData = props.extDashData;
    if (props.extDashData) {
      this.dataUrl = "/data/dash_process_data";
      this.appId = props.extDashData.appId;
      this.widgetId = props.extDashData.widgetId;
      this.entryId = props.extDashData.entryId;
      this.refAppId = null;

      if (props.extDashData.formId.indexOf("@") > -1) {
        let forms = props.extDashData.formId.split("@");
        this.refAppId = forms[1];
        this.formId = forms[0];
      }
    } else {
      if (this.popupFormPath && this.popupFormPath.length) {
        if (props.formId.indexOf("@") > -1) {
          let forms = props.formId.split("@");
          this.appId = forms[1];
          this.formId = forms[0];
          this.entryId = forms[0];
        }
      }
    }
  }

  //请求数据的时候
  cellRenderLoading = (ref) => {
    let loadingEl = ref.querySelector(".content-edit .BsySLoading");
    let components = ref.querySelector(".content-edit .value-components");
    if (loadingEl) {
      loadingEl.style.display = "";
      loadingEl.style.zIndex = "1";
    }
    if (components) {
      components.style.visibility = "hidden";
    }
  };

  reset = () => {
    BsyUtils.forEach(this.formMap, (id, data) => {
      if (this.formMap.hasOwnProperty(id)) {
        delete this.formMap[id];
      }
    });
  };

  getRowData = (ref, rowData, cb) => {
    let _this = this;
    let id = rowData._id;
    if (this.formMap[id]) {
      console.log("缓存数据");

      this.get(id).form.setRowElement();
      cb && cb(this.get(id));
      return;
    }

    if (ref) {
      this.cellRenderLoading(ref);
    }

    React.axios(this.dataUrl, {
      appId: this.appId,
      formId: this.formId,
      entryId: this.entryId,
      refAppId: this.refAppId,
      dataId: id,
      iseditable: false,
      authGroupId: this.authGroupId,
      popupFormPath: this.popupFormPath,
      widgetId: this.widgetId,
    })
      .then((res) => {
        BsyUtils.showAjaxTip(
          res.data,
          () => {
            _this.dataTable.getWidgetMap(res.data.form.items);
            console.log("请求行数据", res.data.data);

            let tmpoptAuth = _this.optAuth;
            if (_this.authGroupId === 0) {
              tmpoptAuth = { ..._this.optAuth, ...rowData.optAuth };
            }
            if (_this.hasOwnProperty("type") && _this.type === "data_table") {
              //报表 可编辑权限根据报表设计走
              tmpoptAuth = { ...rowData.optAuth };
            }

            let optAuth = { ...tmpoptAuth };

            if (res.data.hasOwnProperty("optAuth")) {
              optAuth = { ...optAuth, ...res.data.optAuth }; //$.extend({}, optAuth, g.optAuth)
            }

            let form = new BsyFormWidgetManager({
              dataTable: this.dataTable,
              data: res.data.data,
              fieldShowRules: res.data.form.fieldShowRules,
              subformFieldShowRules: res.data.form.subformFieldShowRules,
              formItems: res.data.form.items,
              multiTabs: res.data.formTabs,
              formTabsStyle: res.data.formTabsStyle || {},
              validators: res.data.form.validators,
              appId: this.appId,
              submitUrl: "/data/update",
              formId: this.formId,
              entryId: this.entryId,
              authGroupId: this.authGroupId,
              widgetId: this.widgetId,
              ignoreAuth: this.ignoreAuth,
              noRely: this.noRely,
              dataUrl: this.dataUrl,
              extDashData: this.extDashData,
              refAppId: this.refAppId,
              optAuth: optAuth,
              popupFormPath: this.popupFormPath,
            });

            form.setRowElement();

            this.set(id, "form", form);
            cb && cb(this.get(id));
          },
          () => {}
        );
      })
      .catch((res) => {
        console.error(res);
      });
  };

  //重置form数据的状态
  // reset = () => {
  //   this.formMap = {}
  // }

  //保存单条数据
  set = (id, key, data) => {
    if (!this.formMap[id]) {
      this.formMap[id] = {};
    }
    if (BsyUtils.isString(key)) {
      if (this.formMap[id][key]) {
        delete this.formMap[id][key];
      }
      this.formMap[id][key] = data;
    } else {
      this.formMap[id] = { ...key };
    }
  };

  //取单条数据
  get = (id) => {
    if (this.formMap.hasOwnProperty(id)) {
      return this.formMap[id];
    }
    return null;
  };

  //移除指定数据
  remove = (ids) => {
    if (Array.isArray(ids)) {
      BsyUtils.forEach(ids, (id, date) => {
        if (this.formMap.hasOwnProperty(date)) {
          delete this.formMap[date];
        }
      });
    } else {
      if (this.formMap.hasOwnProperty(ids)) {
        delete this.formMap[ids];
      }
    }
  };
}
